enum PasswordAuthAppPaths {
  Login = '/login',
  NotFound = '/*',
  ForgotPassword = '/forgot-password',
  ChangePassword = '/change-password',
}

export default PasswordAuthAppPaths;
